import { render, staticRenderFns } from "./VideoGridMotograu.vue?vue&type=template&id=5d045bfd&scoped=true&"
import script from "./VideoGridMotograu.vue?vue&type=script&lang=js&"
export * from "./VideoGridMotograu.vue?vue&type=script&lang=js&"
import style0 from "./VideoGridMotograu.vue?vue&type=style&index=0&id=5d045bfd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d045bfd",
  null
  
)

export default component.exports